export default {
      id: "step-complete-mobile-usage",
      viewBox: "0 0 83 83",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#step-complete-mobile",
      toString: function () {
        return this.url;
      }
    }